import { RewardService, TRegisterRewardParams } from "src/application/ports";
import { convertObjectToFormData } from "src/lib/convertObjectToFormData";
import { api } from "./api";

export function useReward(): RewardService {
  return {
    register({ email, first_name, type, prize }: TRegisterRewardParams) {
      return api({
        method: "post",
        data: convertObjectToFormData({ email, first_name, type, prize }),
        url: "registerAttempt",
        headers: { "Content-Type": "multipart/form-data" },
      });
    },
  };
}
